goog.provide("shadow.js.shim.module$src$svg$inform$plus_svg");
goog.provide("module$shadow_js_shim_module$src$svg$inform$plus_svg");
shadow.js.shim.module$src$svg$inform$plus_svg = shadow.js.nativeProvides["src/svg/inform/plus.svg"] = shadow$bridge("src/svg/inform/plus.svg");
module$shadow_js_shim_module$src$svg$inform$plus_svg.default = shadow.js.shim.module$src$svg$inform$plus_svg;
